import { createClientApp } from 'client/ClientApp'

import '../styles/client.css'

createClientApp()
